import { render, staticRenderFns } from "./contentVideoMobile.vue?vue&type=template&id=65ddff85&scoped=true&"
import script from "./contentVideoMobile.vue?vue&type=script&lang=js&"
export * from "./contentVideoMobile.vue?vue&type=script&lang=js&"
import style0 from "./contentVideoMobile.vue?vue&type=style&index=0&id=65ddff85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ddff85",
  null
  
)

export default component.exports